import Api from '../Utils/Axios';



export const GetEmojiList = async (searchValue = "") => {
    const response = await Api.get(`emoji/list/?search=${searchValue}`);
    return response.data;
  };

  export const CreateEmoji = async (data) => {
    const response = await Api.post('emoji/',data);
    return response.data;
  };

  export const DeleteEmoji = async (id) => {
    const response = await Api.delete(`emoji/${id}`);
    return response.data;
  };

  export const AddImages = async (data) => {
    const response = await Api.post("general/uploadFiles/", data);
    return response.data;
  };

  export const GetSingleEmoji = async (id) => {
    const response = await Api.get(`emoji/${id}`);
    return response.data;
  };

  export const UpdateEmoji = async (data) => {
    const response = await Api.put('emoji/',data);
    return response.data;
  };

  export const DragAndDropEmoji = async (data) => {
    const response = await Api.post('emoji/changeOrder',data);
    return response.data;
  };